import { useCallback, useState } from 'react';

import type { LegacyRef } from 'react';

const HEIGHT_DIFF_TOLERANCE = 5; // pixels

/**
 * Checks whether content is overflowing a DOM node.
 * Sometimes when measuring nodes `scrollHeight` is exactly 1px bigger than `clientHeight`
 * so normal equality is not a good way of checking this
 * (not sure about reason, maybe there is an invisible 1px high scrollbar?)
 * Regardless we really only care about situations where there it at least 1 line of text
 * overflowing, se we can ignore differences of 1-2 pixels and just check if the sizes are similar
 */
function isContentOverflowing(node: HTMLElement) {
  return (
    Math.abs(node.scrollHeight - node.clientHeight) > HEIGHT_DIFF_TOLERANCE
  );
}

function useIsOverflown(): [boolean, LegacyRef<HTMLDivElement>] {
  const [isOverflown, setIsOverflown] = useState(false);

  const ref: LegacyRef<HTMLDivElement> = useCallback((node) => {
    if (node !== null) {
      setIsOverflown(isContentOverflowing(node));
    }
  }, []);
  return [isOverflown, ref];
}

export { useIsOverflown };
